module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Kettle-5d47e773d3ae83da7f38d0135f009021.svg";